import * as MatStyled from "@mui/material/styles";

import QuoDraftListAdmin from "./admin";
import QuoDraftListSeller from "./seller";
import { useAuth } from "src/hooks/useAuth";

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: "16px 20px",
  [theme.breakpoints.up("sm")]: {
    padding: "24px 40px",
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
  },
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  width: "100%",
  marginTop: "75px",
  background: "#fff",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
  [theme.breakpoints.down("sm")]: {
    marginTop: "64px",
  },
}));

const QuoDraftList = ({ open }) => {
  const { checkAllowPermission } = useAuth();
  // const saleEmailList = [
  // 	'salesonline@xsurface.com',
  // 	'support@xsurface.com',
  // 	'salesmgr@xsurface.com',
  // 	'develop_charinrat.b@xsurface.com',
  // 	'webdev@xsurface.com', //for test
  // ];
  // const adminEmailList = [
  //   "webdev@xsurface.com"
  // ];

  return (
    <Main open={open}>
      {/* ***** Admin ***** */}
      {/* {userData?.role_id === 1 ? (
        <QuoDraftListAdmin />
      ) : (
        <QuoDraftListSeller />
      )} */}

      {/* ***** check email is sale (ชั่วคราว) ****** */}
      {/* {saleEmailList.includes(userData?.email) ? (
        <QuoDraftListSeller />
      ) : (
        <QuoDraftListAdmin />
      )} */}

      {/* ***** check email is admin (ชั่วคราว) ****** */}
      {checkAllowPermission("sale_features.can_view_adminQuotation") ? (
        <QuoDraftListAdmin />
      ) : (
        <QuoDraftListSeller />
      )}
    </Main>
  );
};

export default QuoDraftList;
